import React from "react";
import { Link } from "react-router-dom";
import "./ContactCTA.scss";

const ContactCTA = () => {
    return (
        <section
            className="contact-cta"
            id="contact"
            aria-labelledby="contact-cta-title"
        >
            <div className="contact-cta__inner">
                <div className="contact-cta__content">
                    <p className="contact-cta__eyebrow">Connect with Techadive</p>

                    <h2 id="contact-cta-title">
                        Let’s Build Your <span>Next Opportunity.</span>
                    </h2>

                    <p className="contact-cta__description">
                        Have a technology project in mind, a partnership to explore, or
                        an interest in our ventures? Let’s start a conversation.
                    </p>

                    <Link className="contact-cta__button" to="/contact">
                        Let’s Talk
                        <span aria-hidden="true">↗</span>
                    </Link>

                    <ul className="contact-cta__topics" aria-label="Enquiry topics">
                        <li>Technology Projects</li>
                        <li>Invest Africa &amp; Partnerships</li>
                        <li>Our Ventures</li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default ContactCTA;